import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateSEO, resetSEO } from 'src/utils/seo';

/**
 * Custom hook for managing SEO meta tags
 * @param {Object} seoData - SEO data object
 */
export const useSEO = (seoData) => {
  const location = useLocation();

  useEffect(() => {
    if (seoData) {
      // Ensure URL is set from current location
      const fullSeoData = {
        ...seoData,
        url: seoData.url || window.location.href,
      };
      updateSEO(fullSeoData);
    } else {
      // Reset to default if no SEO data provided
      resetSEO();
    }

    // Cleanup function to reset SEO on unmount (optional)
    return () => {
      // Don't reset on unmount to prevent flickering during navigation
      // resetSEO();
    };
  }, [location.pathname, seoData]);
};

export default useSEO;

